import { EmoticonExcitedIcon } from './EmoticonExcitedIcon';

/**
 * author: Google
 * id 86E664CC-39C1-4E36-81BB-AC3BFFE65281
 * name emoticon-excited
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/emoticon-excited.svg
 * tags
 * - Emoji 
 */
export const EmojiExcitedIcon = EmoticonExcitedIcon;
export default EmojiExcitedIcon